<template lang="html">

<svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29">
    <g :fill="colors.basic" fill-rule="evenodd">
        <path d="M14.855 3.083c6.1 0 11.05 4.893 11.05 10.923s-4.95 10.922-11.05 10.922c-6.1 0-11.05-4.891-11.05-10.922 0-6.03 4.95-10.923 11.05-10.923m0 23.63c7.096 0 12.855-5.692 12.855-12.707 0-7.015-5.759-12.707-12.855-12.707C7.758 1.299 2 6.99 2 14.006c0 7.015 5.758 12.707 12.855 12.707"/>
        <path d="M20.293 8L15 13.294 9.707 8h-.002L9 8.706l5.294 5.293L9 19.293l.706.707L15 14.706 20.294 20l.705-.707-5.293-5.294 5.293-5.293L20.295 8z"/>
    </g>
</svg>


</template>

<script lang="js">
  
  import {mapGetters} from 'vuex';

  export default  {
    name: 'add',
    props: [],
    computed : {
      ...mapGetters({
        colors : 'basicColors'
      })
    }
}
</script>

<style scoped lang="scss">
  .add {

  }
</style>



// WEBPACK FOOTER //
// src/components/parts/icons/salir.vue